import React from 'react';

const SelectPayMethod = (props) => {
    const { data, seleccionarCombo } = props;
    const { Validaciones, ValidarPantalla, errorEnWebService } = data;

    const optionFormaDebitos = data.GET_FORMA_DEBITO.map((formaDebito, index) => {
        return (
            <option value={formaDebito.Id} key={"forma-debito-option-" + index}>
                {formaDebito.Descripcion}
            </option>
        );
    });

    const optionSucursales = data.GET_SUCURSAL_CUENTA.map((sucursal, index) => {
        return (
            <option value={sucursal.Id} key={"sucursal-option-" + index} data-codigo={sucursal.Codigo}>
                {sucursal.Codigo + " - " + sucursal.Descripcion}
            </option>
        );
    });

    let mensajeErrorFormDebito = null;
    let mensajeErrorCuentaSucursal = null;
    let mensajeErrorCuentaNumero = null;

    if (ValidarPantalla == true) {
        if (Validaciones.FormaDebitoSeleccionada == false) {
            mensajeErrorFormDebito = <label className="error">Debe al menos una forma de debito</label>;
        }
        if (Validaciones.CuentaBancariaSucursalSeleccionada == false) {
            mensajeErrorCuentaSucursal = <label className="error">Debe seleccionar al menos una sucursal</label>;
        }
        if (Validaciones.CuentaBancariaNumeroSeleccionada == false) {
            mensajeErrorCuentaNumero = <label className="error">Debe seleccionar al menos cuenta bancaria</label>;
        }
    }

    let cuentasBancariasComp = null;

    if (errorEnWebService == false) {
        const cuentasBancarias = data.GET_LISTAR_POR_DOCUMENTO_ITAU ?
            JSON.parse(JSON.stringify(data.GET_LISTAR_POR_DOCUMENTO_ITAU)) != "" ?
                JSON.parse(JSON.stringify(data.GET_LISTAR_POR_DOCUMENTO_ITAU)) : [] : [];

        if (cuentasBancarias[0].Cuenta.hasOwnProperty('Numero')) {
            const optionCuentaBancarias = cuentasBancarias.filter((c1) => c1.Cuenta.Sucursal == data.Cuenta.CuentaBancariaSucursalCodigo).map((c2, index) => {
                return (
                    <option value={c2.Cuenta.Numero} key={"cuenta-numero-" + index} data-tipo={c2.Cuenta.Tipo}>
                        {c2.Cuenta.Numero}
                    </option>
                );
            });

            cuentasBancariasComp = (<div>
                <select value={data.Cuenta.CuentaBancariaNumero} className="form-control default-select"
                    onChange={(event) => {
                        let index = event.target.selectedIndex;
                        let optionActual = event.target.options[index];

                        seleccionarCombo(event.target.value, "CUENTA-BANCARIA", optionActual.dataset.tipo)
                    }}>
                    <option value="0">Seleccione...</option>
                    {optionCuentaBancarias}
                </select>
                {mensajeErrorCuentaNumero}
            </div>);
        }
        else {
            cuentasBancariasComp = <label className="alert-danger">{cuentasBancarias}</label>;
        }
    } else {
        cuentasBancariasComp = <label className="alert-danger">Error en el webservices</label>;
    }

    return (
        <div className="row">
            <div className="col-xs-4">
                <label className="label-primary">Importe a debitar</label>
                <select value={data.Cuenta.FormaDebitoId} className="form-control default-select"
                    onChange={(event) => { seleccionarCombo(event.target.value, "IMPORTE-DEBITAR") }}>
                    <option value="0">Seleccione...</option>
                    {optionFormaDebitos}
                </select>
                {mensajeErrorFormDebito}
            </div>
            <div className="col-xs-4">
                <label className="label-primary">Sucursal de la cuenta</label>
                <select value={data.Cuenta.CuentaBancariaSucursalId} className="form-control default-select"
                    onChange={(event) => {
                        let index = event.target.selectedIndex;
                        let optionActual = event.target.options[index];

                        seleccionarCombo(event.target.value, "SUCURSAL-CUENTA", optionActual.dataset.codigo)
                    }}>
                    <option value="-1">Seleccione...</option>
                    {optionSucursales}
                </select>
                {mensajeErrorCuentaSucursal}
            </div>
            <div className="col-xs-4">
                <label className="label-primary">Cuenta</label>
                {cuentasBancariasComp}
            </div>
        </div>
    );
}

export default SelectPayMethod;